import { PayloadProps } from './types';

export type ReducerAction =
  | {
      type:
        | typeof REDUX_BASKET_ADD
        | typeof REDUX_BASKET_REMOVE
        | typeof REDUX_SHOPPING_LIST_ADD
        | typeof REDUX_SHOPPING_LIST_REMOVE;
      payload: string;
    }
  | {
      type: typeof REDUX_BASKET_CERTAIN_QUANTITY_ADD | typeof REDUX_BASKET_REMOVE_QUANTITY;
      payload: PayloadProps;
    }
  | {
      type: typeof REDUX_BASKET_SET;
      payload: PayloadProps[];
    };

export const REDUX_BASKET_ADD = Symbol('REDUX_BASKET_ADD');
export const REDUX_BASKET_CERTAIN_QUANTITY_ADD = Symbol('REDUX_BASKET_CERTAIN_QUANTITY_ADD');
export const REDUX_BASKET_REMOVE = Symbol('REDUX_BASKET_REMOVE');
export const REDUX_BASKET_REMOVE_QUANTITY = Symbol('REDUX_BASKET_REMOVE_QUANTITY');
export const REDUX_BASKET_SET = Symbol('REDUX_BASKET_SET');
export const REDUX_BASKET_UPDATED = Symbol('REDUX_BASKET_UPDATED');

export const REDUX_SHOPPING_LIST_ADD = Symbol('REDUX_SHOPPING_LIST_ADD');
export const REDUX_SHOPPING_LIST_REMOVE = Symbol('REDUX_SHOPPING_LIST_REMOVE');
export const REDUX_SHOPPING_LIST_UPDATED = Symbol('REDUX_SHOPPING_LIST_UPDATED');

export const PRODUCTS_ADD_TO_SHOPPING_LIST = 'products/ADD_TO_SHOPPING_LIST';
export const PRODUCTS_REMOVE_FROM_SHOPPING_LIST = 'products/REMOVE_FROM_SHOPPING_LIST';

export function addToBasket(id: string) {
  return { type: REDUX_BASKET_ADD, payload: id };
}

export function addCertainQuantityToBasket(payload: PayloadProps) {
  return { type: REDUX_BASKET_CERTAIN_QUANTITY_ADD, payload };
}

export function removeFromBasket(id: string) {
  return { type: REDUX_BASKET_REMOVE, payload: id };
}

export function setBasket(payload: PayloadProps[]) {
  return { type: REDUX_BASKET_SET, payload };
}
